// ======================================================================
// Forge Lite | hello@hashandsalt.com
// ======================================================================

// ======================================================================
// Module Imports
// ======================================================================

import lozad from 'lozad';
import Swiper from 'swiper';
import EffectPanorama from './effect-panorama.esm.js';
import 'swiper/css';

// ======================================================================
// Lazy Loading (Lozad)
// ======================================================================

const observer = lozad('.lozad', {
  rootMargin: '50%', // Pre-load images beyond the viewport by 50%
});
observer.observe();

// ======================================================================
// Swiper Carousel
// ======================================================================

const swiper = new Swiper('.panorama-slider .swiper', {
  // pass Panorama module
  modules: [EffectPanorama],
  // enable "panorama" effect
  effect: 'panorama',
  slidesPerView: 1.33,
  loop: true,
  lazy: true,
  lazyPreloadPrevNext: 2,
  centeredSlides: true,
  grabCursor: true,
  pagination: {
    el: '.swiper-pagination',
    dynamicBullets: true,
    dynamicMainBullets: 3,
  },
  // panorama effect parameters
  panoramaEffect: {
    rotate: 35,
    depth: 150,
  },
  breakpoints: {
    460: {
      slidesPerView: 1.66,
      panoramaEffect: {
        rotate: 30,
        depth: 150,
      },
    },
    768: {
      slidesPerView: 2.95,
      panoramaEffect: {
        rotate: 25,
        depth: 200,
      },
    },
    1024: {
      slidesPerView: 3.33,
      panoramaEffect: {
        rotate: 20,
        depth: 200,
      },
    },
    1280: {
      slidesPerView: 4,
      panoramaEffect: {
        rotate: 16,
        depth: 250,
      },
    },
    1440: {
      slidesPerView: 4.45,
      panoramaEffect: {
        rotate: 10,
        depth: 300,
      },
    },
  },
});

// ======================================================================
// Scroll to Top
// ======================================================================

const backToTopBtn = document.getElementById('backtotop');

if (backToTopBtn) {
  backToTopBtn.addEventListener('click', () => {
    document.getElementById('header')?.scrollIntoView({ behavior: 'smooth' });
  });
}

// ======================================================================
// Debug (Optional)
// ======================================================================
// console.log(`Window Width: ${window.innerWidth}`);
// console.log(`Window Height: ${window.innerHeight}`);
